import "babel-polyfill";
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { Layout, ConfigProvider, Spin, Icon } from 'antd';
import { IntlProvider, addLocaleData } from 'react-intl';

//import './locale/zh-Hans-CN';
import './locale/en-US';

import { Router, Route, Switch } from 'react-router-dom';

import store from './helpers/store';
import history from './helpers/history';

import { RestrictedPage, HeaderPage, FooterPage } from './pages';

//import HomePage from './pages/home/HomePage';
import LoginPage from './pages/auth/Login';
import RegisterPage from './pages/auth/Register';
import ForgetPage from './pages/auth/Forget';

import HelpPage from './pages/help/HelpPage';
import DownloadPage from './pages/download/DownloadPage';
import VideoPage from './pages/video/VideoPage';

import AboutPage from './pages/about/AboutPage';

import BlankPage from './pages/blank/BlankPage';
import TestPage from './pages/test/TestPage';

import ServicePage from './pages/stripe/ServicePage';
import ChargePage from './pages/stripe/ChargePage';
import SubscriptionPage from './pages/stripe/SubscriptionPage';

import BillingPage from './pages/stripe/BillingPage';
import UpdatePage from './pages/stripe/UpdatePage';

import HawkeyePage from './pages/hawkeye/HawkeyePage';
import HawkeyeListPage from './pages/hawkeye/HawkeyeListPage';

import ConceptPage from './pages/concept/ConceptPage';
import EditStrategyPage from './pages/concept/EditStrategyPage';
import VernacularPage from './pages/vernacular/VernacularPage';
import MyStrategyPage from './pages/vernacular/MyStrategyPage';
import UpdateStrategyPage from './pages/strategy/UpdateStrategyPage';

import StrategyPage from './pages/strategy/StrategyPage';
import CustomStockPage from './pages/customStock/CustomStockPage';

import OptionPage from './pages/option/OptionPage';

import FactorPage from './pages/factor/FactorPage';
import FactorIndex from './pages/factor/FactorIndex';
import FactorAnalyzer from './pages/factor/FactorAnalyzer';

import Correlation from './pages/correlation/index';

import BacktestPage from './pages/backtest/BacktestPage';
import MyBacktestPage from './pages/backtest/MyBacktestPage';

import OptimalGridPage from './pages/backtest/OptimalGridPage';
import MyOptimalGridPage from './pages/backtest/MyOptimalGridPage';

import OptimalBatchPage from './pages/backtest/OptimalBatchPage';
import MyOptimalBatchPage from './pages/backtest/MyOptimalBatchPage';

import OptimalOptPage from './pages/backtest/OptimalOptPage';
import MyOptimalOptPage from './pages/backtest/MyOptimalOptPage';

import BacktestGridPage from './pages/backtest/BacktestGridPage';
import MyBacktestGridPage from './pages/backtest/MyBacktestGridPage';
import AIGridPage from './pages/backtest/AIGridPage';
import MyAIGridPage from './pages/backtest/MyAIGridPage';

import AIBatchPage from './pages/backtest/AIBatchPage';
import MyAIBatchPage from './pages/backtest/MyAIBatchPage';

import AIOptPage from './pages/backtest/AIOptPage';
import MyAIOptPage from './pages/backtest/MyAIOptPage';


import RealTimePage from './pages/trade/RealTimePage';
import SimulationPage from './pages/trade/SimulationPage';

import GeneralStrategyPage from './pages/trade/GeneralStrategyPage';
import RealTimeGeneralStrategyPage from './pages/trade/RealTimeGeneralStrategyPage';

import RollingPage from './pages/backtest/RollingPage';
import MyRollingPage from './pages/backtest/MyRollingPage';

import TdAmeritradePage from './pages/tdAmeritrade/TdAmeritradePage';

import FilterPage from './pages/filter/FilterPage';
import MyFilterPage from './pages/filter/MyFilterPage';
import UpdateFilterPage from './pages/filter/UpdateFilterPage';

import PortfolioPage from './pages/portfolio/PortfolioPage';
import MyPortfolioPage from './pages/portfolio/MyPortfolioPage';

import PortfolioOptPage from './pages/portfolio/PortfolioOptPage';
import MyPortfolioOptPage from './pages/portfolio/MyPortfolioOptPage';

import ScanPage from './pages/vernacular/ScanPage';

import ChatPage from './pages/vernacular/ChatPage';
import { ChatProvider } from './pages/ChatProvider';


import OrderPage from './pages/order/OrderPage';


import PageNotFound from './pages/layout/PageNotFoundPage';

import "antd/dist/antd.css";
//import './index.css';
import './index-us.css';

//window.webType = 'CN';
window.webType = 'US';

const appLocale = window.appLocale;
addLocaleData(appLocale.data);

//const ConceptPage = React.lazy(() => import('./pages/concept/ConceptPage'));
//const EditStrategyPage = React.lazy(() => import('./pages/concept/EditStrategyPage'));
//const VernacularPage = React.lazy(() => import('./pages/vernacular/VernacularPage'));
//const MyStrategyPage = React.lazy(() => import('./pages/vernacular/MyStrategyPage'));
//const StrategyPage = React.lazy(() => import('./pages/strategy/StrategyPage'));
//const CustomStockPage = React.lazy(() => import('./pages/customStock/CustomStockPage'));
const MemberPage = React.lazy(() => import('./pages/member/MemberPage'));
const CouponPage = React.lazy(() => import('./pages/member/CouponPage'));

//const OptionPage = React.lazy(() => import('./pages/option/OptionPage'));

//const FactorPage = React.lazy(() => import('./pages/factor/FactorPage'));
//const FactorIndex = React.lazy(() => import('./pages/factor/FactorIndex'));
//const FactorAnalyzer = React.lazy(() => import('./pages/factor/FactorAnalyzer'));

//const HawkeyePage = React.lazy(() => import('./pages/hawkeye/HawkeyePage'));
//const HawkeyeListPage = React.lazy(() => import('./pages/hawkeye/HawkeyeListPage'));

Spin.setDefaultIndicator(<Icon type="loading" className='common-loading-icon' spin />);
const Loading = () => <div className='common-root-loading-container'><div className='common-root-loading'><Spin></Spin></div></div>
const rootElement = document.getElementById('root');
ReactDOM.render(
    <ConfigProvider locale={appLocale.antd}>
        <IntlProvider locale={appLocale.locale} messages={appLocale.messages}>
            <Provider store={store}>
                <ChatProvider>
                <Router history={history}>
                    <Layout>
                        <HeaderPage />
                        <Switch>
                        
                            <Route exact path="/scan_test" component={() => <Suspense fallback={<Loading />}><ScanPage /></Suspense>} />

                            <Route exact path="/scan" component={() => <ChatPage />} />
                            <Route exact path="/" component={() => <ChatPage />} />
                            
                            <Route path="/login" component={() => <LoginPage />} />
                            <Route path="/register" component={() => <RegisterPage />} />
                            <Route path="/forget" component={() => <ForgetPage />} />

                            <Route path="/help" component={() => <HelpPage />} />
                            <Route path="/download" component={() => <DownloadPage />} />
                            <Route path="/video" component={() => <VideoPage />} />

                            <Route path="/f" component={() => <FilterPage />} />
                            <Route path="/mf" component={() => <MyFilterPage />} />
                            <Route path="/uf" component={() => <UpdateFilterPage />} />

                            <Route path="/concept" component={() => <ConceptPage />} />
                            <Route path="/editStrategy" component={() => <EditStrategyPage />} />

                            
                            <Route path="/myStrategy" component={() => <MyStrategyPage />} />

                            <Route path="/strategy" component={() => <StrategyPage />} />
                            <Route path="/customStock" component={() => <CustomStockPage />} />
                            <Route path="/usp" component={() => <UpdateStrategyPage />} />

                            <Route path="/bt" component={() => <BacktestPage />} />
                            <Route path="/mbt" component={() => <MyBacktestPage />} />

                            <Route path="/ogbt" component={() => <OptimalGridPage />} />
                            <Route path="/mogbt" component={() => <MyOptimalGridPage />} />

                            <Route path="/ob" component={() => <OptimalBatchPage />} />
                            <Route path="/mob" component={() => <MyOptimalBatchPage />} />

                            <Route path="/oo" component={() => <OptimalOptPage />} />
                            <Route path="/moo" component={() => <MyOptimalOptPage />} />

                            <Route path="/bg" component={() => <BacktestGridPage />} />
                            <Route path="/mbg" component={() => <MyBacktestGridPage />} />
                            <Route path="/aig" component={() => <AIGridPage />} />
                            <Route path="/maig" component={() => <MyAIGridPage />} />

                            <Route path="/aib" component={() => <AIBatchPage />} />
                            <Route path="/maib" component={() => <MyAIBatchPage />} />

                            <Route path="/aio" component={() => <AIOptPage />} />
                            <Route path="/maio" component={() => <MyAIOptPage />} />

                            <Route path="/re" component={() => <RealTimePage />} />
                            <Route path="/si" component={() => <SimulationPage />} />

                            <Route path="/gs" component={() => <GeneralStrategyPage />} />
                            <Route path="/rtgs" component={() => <RealTimeGeneralStrategyPage />} />

                            <Route path="/rr" component={() => <RollingPage />} />
                            <Route path="/mrr" component={() => <MyRollingPage />} />

                            <Route path="/option" component={() => <OptionPage />} />
                            <Route path="/factor" component={() => <FactorPage />} />
                            <Route path="/factorIndex" component={() => <FactorIndex />} />
                            <Route path="/factorAnalyzer" component={() => <FactorAnalyzer />} />

                            <Route path="/hawkeye" component={() => <HawkeyePage />} />
                            <Route path="/hawkeyeList" component={() => <HawkeyeListPage />} />

                            <Route path="/member" component={() => <RestrictedPage><Suspense fallback={<Loading />}><MemberPage /></Suspense></RestrictedPage>} />
                            <Route path="/coupon" component={() => <RestrictedPage><Suspense fallback={<Loading />}><CouponPage /></Suspense></RestrictedPage>} />

                            <Route path="/about" component={() => <AboutPage />} />

                            <Route path="/blank" component={() => <BlankPage />} />

                            <Route path="/test" component={() => <TestPage />} />
                            <Route path="/td" component={() => <TdAmeritradePage />} />
                            
                            <Route path="/service" component={() => <ServicePage />} />
                            <Route path="/charge" component={() => <ChargePage />} />
                            <Route path="/sc" component={() => <SubscriptionPage />} />
                            <Route path="/b" component={() => <BillingPage />} />
                            <Route path="/su" component={() => <UpdatePage />} />

                            <Route path="/co" component={() => <Correlation />} />

                            <Route path="/po" component={() => <PortfolioPage />} />
                            <Route path="/mpo" component={() => <MyPortfolioPage />} />

                            <Route path="/poo" component={() => <PortfolioOptPage />} />
                            <Route path="/mpoo" component={() => <MyPortfolioOptPage />} />

                            <Route path="/order" component={() => <OrderPage />} />

                            <Route component={PageNotFound} />
                        </Switch>
                        <FooterPage />
                    </Layout>
                    </Router>
                </ChatProvider>
            </Provider>
        </IntlProvider>
    </ConfigProvider>,
    rootElement);
                        
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
                
//serviceWorker();
